// extracted by mini-css-extract-plugin
export default {"content":"RI-z","lookName":"SI-z","shopTheLookContainer":"TI-z","productContainer":"UI-z","imageContainer":"VI-z","mainImage":"WI-z"};